<template>
  <div>
    <div >
      <el-menu  
      :default-active="activeMenuIndex"
        class="el-menu-vertical-demo" 
      :unique-opened=true
      text-color="#52535E"
      active-text-color="#1890FF">
      <div class="New_Menu" v-for="(menu, index) in copy_Menus" :key="menu.id">
        <el-menu-item :index="(index+1)+''" @click="getMenuUrl(menu.alias,menu.name)" >
          <i class="iconfont icon-shouye" v-if="menu.name=='首页'"><p slot="title">{{menu.name}}</p></i>
          <i class="iconfont icon-yingyongchengxu" v-if="menu.name=='应用'" data-step="5" data-intro="流程类、报表类、管理类等应用入口~"><p slot="title">{{menu.name}}</p></i>
          <i class="iconfont icon-yiban-wancheng-07" v-if="menu.name=='事项'" data-step="6" data-intro="跟进及审批事项汇总~"><p slot="title">{{menu.name}}</p></i>
          <i class="iconfont icon-gonggao2" v-if="menu.name=='公告'" data-step="7" data-intro="内部公告及外部新闻汇总~"><p slot="title">{{menu.name}}</p></i>
          <i class="iconfont icon-kaoqin1" v-if="menu.name=='考勤'" data-step="8" data-intro="日常考勤明细及假期入口~"><p slot="title">{{menu.name}}</p></i>
          <i class="iconfont icon-a-gongzuotaigongzuozhuo-06" v-if="menu.name=='工作台'"><p slot="title">{{menu.name}}</p></i>
          <i class="iconfont icon-shezhi" v-if="menu.name=='设置'" data-step="9" data-intro="设置自定义特色功能~"><p slot="title">{{menu.name}}</p></i>      
          <i class="iconfont icon-lianxiren" style="position:relative" v-if="menu.name=='联系人'" data-step="10" data-intro="公司内部通讯录~">  
            <el-badge is-dot class="item" v-show="!isRead && menu.name=='联系人'" style="position:absolute;top:12px;right:15px" />
            <p slot="title">{{menu.name}}</p>
          </i>           
        </el-menu-item>
        
      </div>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
// import utils from "@/hotent-ui-util.js";
import utils1 from "@/utils.js";
export default {
  data() {
    return {
      copy_Menus: [],
      resizeTick: false,
      firstMenuChange: false,
      templateMoreAlias: "_templateMoreMenu", //临时更多目录的别名
      activeMenuIndex: "0-0", //默认选择首页
      Menuindex:"",
      isRead:false
    };
  },
  computed: mapState({
    menus: (state) => state.menu.all,
    residual: (state) => state.menu.residual,
    menuMaps: (state) => state.menu.menuMaps,
    currentMenu: (state) => state.menu.currentMenu,
    account: state => state.login.currentUser.account
  }),
  watch: {
    "currentMenu.alias":{
      handler(val){
        this.activeMenuIndex = val;
      },
    }
  },
  methods: {
    getMenuUrl(alias,name){
      this.isRead = true;
      sessionStorage.MenuName = name;
      sessionStorage.menu_alias = alias;
      if(alias=="backmenu"){//工作台
        this.setCurrentMenu('backmenu');
        this.routerAdd("/backmenu"); //动态添加路由
        this.$router.push({ path: '/backmenu'});
        utils1.reload();
      }else{
        this.$router.push({path:"/"+alias});
        utils1.reload();
      }
    },
    getAppUrl(alias1,alias2,index,name){//点击应用中心一级菜单
      // this.activeMenuIndex = index;
      // sessionStorage.MenuName = name;
      // sessionStorage.menu_alias = index;
      // sessionStorage.Menuindex = "/"+alias1+"/"+alias2;

      // if(alias1=="appCenterFront"){//应用中心
      //   //window.location.href = "/"+alias1+"?menu="+alias2;//解决url带参数，vue组件路径不改变导致b页面不刷新
      //   this.$router.push({path:"/"+alias1+"?menu="+alias2})
      //   utils1.reload();
      // }else if(alias1=="backmenu"){//跳转mvue
      //   this.setCurrentMenu('backmenu');
      //   this.routerAdd("/backmenu"); //动态添加路由
      //   this.$router.push({ path: '/backmenu/'+alias2});
      // }else if(alias2.indexOf("template/preview")>=0){//数据报表
      //   this.routerAdd("/v-flow"); //动态添加路由
      //   this.$router.push({ path: '/v-flow/'+alias2 });
      // }else{
      //   // window.location.href = "/"+alias1+"/"+alias2;
      //   this.$router.push({path:"/"+alias1+"/"+alias2})
      // }
    },
    ShowHome(){//点击首页
      sessionStorage.menu_alias = "";
      this.$router.push({ path: '/home' });
    },
    //动态新增二级路由
    addList(path, list) {
      const that = this;
      let isAddPath = false;
      let isChildren = false;
      for (let i = 0; i < list.length; i++) {
        //判断当前点击菜单的路由别名是否存在 router.js 里面
        if (path == list[i].path) {
          //存在
          //动态注册路由
          let index = path.replace("/", "");
          let templatePreview_new = {
            path: "template/preview/:templateKey",
            name: "templatePreview_" + index,
            props: true,
            component: (resolve) =>
              require([
                "@/components/dataTemplate/templatePreview.vue",
              ], resolve),
          }; //数据报表
          let templateHref_new = {
            path: "href/template/:alias",
            name: "templateHref_" + index,
            props: true,
            component: (resolve) =>
              require(["@/components/dataTemplate/templateHref.vue"], resolve),
            }; //URL菜单
          let querySql_new = {
            path: "querySql/queryView/:sqlAlias/:alias",
            name: "querySql_" + index,
            props: true,
            component: (resolve) =>
              require(["@/components/querySql/querySqlContent.vue"], resolve),
          }; //自定义视图
          let template_new = {
            path: "template/form/:templateKey/:action",
            name: "template_" + index,
            props: true,
            component: (resolve) =>
              require(["@/components/dataTemplate/templateForm.vue"], resolve),
          }; //数据报表
          let templateSingle_new = {
            path: "template/form/:templateKey/:action/:single",
            name: "templateSingle_" + index,
            props: true,
            component: (resolve) =>
              require(["@/components/dataTemplate/templateForm.vue"], resolve),
          }; //数据报表
          let templateQuerys_new = {
            path: "template/preview/:templateKey/:single/:parameterqQuerys",
            name: "templateQuerys_" + index,
            props: true,
            component: (resolve) =>
              require([
                "@/components/dataTemplate/templatePreview.vue",
              ], resolve),
          }; //数据报表
          if (list[i].children) {
            //判断是否重复添加路由
            for (let j = 0; j < list[i].children.length; j++) {
              let children = list[i].children[j];
              if (children.name == templatePreview_new.name) {
                isAddPath = true; // true ： 重复路由
                break;
              }
            }

            if (!isAddPath) {
              list[i].children.push(templatePreview_new);
              list[i].children.push(templateHref_new);
              list[i].children.push(querySql_new);
              list[i].children.push(template_new);
              list[i].children.push(templateSingle_new);
              list[i].children.push(templateQuerys_new);
              that.$router.$addRoutes(list);
            }
            isChildren = true;
            break;
          }
        }
      }
      return isChildren;
    },
    //动态添加路由
    routerAdd(path) {
      const that = this;
      let isChildren = that.addList(path, that.$router.options.routes); //动态新增二级路由
      //当前点击菜单的路由别名不存在 router.js 里面
      if (!isChildren) {
        let alias_new = {
          path: path,
          name: "alias_" + path.replace("/", ""),
          component: (resolve) => require(["@/views/menuContent.vue"], resolve),
          children: [],
        };
        that.$router.options.routes.push(alias_new);
        that.addList(path, that.$router.options.routes); //动态新增二级路由
      }
    },
    handleSelect(alias) {
      return;
      if (!alias) {
        return;
      }
      //把选择的一级菜单别名存入sessionStorage
      sessionStorage.menu_alias = alias;
      //选择一级菜单时
      let clickMenu = this.menus.find((m) => m.alias == alias);
      if (!clickMenu) {
        const moreMenu = this.menus.find(
          (m) => m.alias == this.templateMoreAlias
        );
        moreMenu &&
          moreMenu.children &&
          (clickMenu = moreMenu.children.find((m) => m.alias == alias));
      }

      if (clickMenu) {
        let path = "";
        if (clickMenu.path == undefined) {
          path = clickMenu.alias;
        } else {
          path = clickMenu.path;
        }
        if (path.indexOf("/") < 0) {
          path = "/" + path;
        }
        this.setCurrentMenu(alias);
        if (
          sessionStorage.menu_path &&
          sessionStorage.menu_path.indexOf(alias) != -1
        ) {
          path = sessionStorage.menu_path;
        } else {
          sessionStorage.menu_path = "";
        }
        //点击首页
        if (alias == "home") {
          sessionStorage.menu_alias = "";
          this.$router.push({ path: path });
        } else {
          //其他一级菜单
          this.routerAdd("/" + alias); //动态添加路由
          this.$router.push({ path: path });
        }
      }
    },
    setCurrentMenu(alias) {
      let that = this;
      for (let i = 0; i < that.menus.length; i++) {
        if (that.menus[i].alias === alias) {
          this.$store.dispatch("menu/getCurrentMenu", {
            alias: that.menus[i].alias,
            name: that.menus[i].name,
          });
          break;
        }
      }
    },
    // 页面缩放计时触发器（避免页面缩放频繁触发，导致菜单会频繁更新）
    resizeTimerTrigger() {
      if (this.resizeTick || this.residual) {
        return;
      }
      this.resizeTick = true;
      setTimeout(() => {
        this.handleMenuOverMore();
        this.resizeTick = false;
      }, 1000);
    },
    // 移除Menus中的临时更多菜单
    removeTemplateMoreMenu(menus) {
      let targetIndex = -1;
      // 查找菜单中是否有临时更多菜单
      const moreMenu = menus.find((m, index) => {
        if (m.alias == this.templateMoreAlias) {
          targetIndex = index;
          return m;
        }
      });
      // 如果有，则删掉这个菜单
      if (targetIndex > -1) {
        menus.splice(targetIndex, 1);
      }
      return targetIndex > -1;
    },
    // 处理目录显示宽度超限的情况
    handleMenuOverMore() {
      const menuContainer = this.$refs.menuContainer;
      if (
        !menuContainer ||
        !menuContainer.$children ||
        menuContainer.$children.length == 0
      ) {
        return;
      }

      const containerWidth = menuContainer.$el.clientWidth;
      // 目录宽度超限的元素索引
      let boundaryIndex = 0;
      var childrenTotalWidth = menuContainer.$children.reduce(
        (cur, child, index) => {
          let t = child.$el.clientWidth + cur;
          if (t > containerWidth && boundaryIndex == 0) {
            boundaryIndex = index;
          }
          return t;
        },
        0
      );
      // 如果宽度超限，把menus分为常规菜单和更多菜单
      if (childrenTotalWidth > containerWidth) {
        let copyMenus = [...this.menus];
        this.removeTemplateMoreMenu(copyMenus);
        // 在超限索引大于2时才把超过的目录显示在更多中
        if (boundaryIndex > 2) {
          let moreMenuChildren = [];

          copyMenus
            .filter((m, i) => i > boundaryIndex - 2)
            .forEach((m) => {
              let nm = { ...m };
              moreMenuChildren.push(nm);
              // 把超出部分的菜单标记为隐藏
              m.hidden = true;
            });

          let moreMenu = {
            id: "-2",
            name: "更多",
            alias: this.templateMoreAlias,
            children: moreMenuChildren,
          };
          copyMenus.push(moreMenu);
          this.$store.dispatch("menu/setTemplateMenus", copyMenus);
        } else {
          // throw "屏幕太窄，菜单可能显示不全";
          console.log("屏幕太窄，菜单可能显示不全");
        }
      }
      // 否则把更多菜单合并到menus中
      else {
        let copyMenus = [...this.menus],
          needDispath = this.removeTemplateMoreMenu(copyMenus);

        // 如果有，则重置为原来的菜单
        if (needDispath) {
          copyMenus.forEach((m) => delete m["hidden"]);
          this.$store.dispatch("menu/setTemplateMenus", copyMenus);
        }
      }
    },
  },
  created() {
    $(".is-active").css({"background":"#F0F2F5 !important","box-shadow":"inset -3px 0px 0px 0px #1890FF !important;"});

    if(sessionStorage.Menuindex){
      this.Menuindex = sessionStorage.Menuindex;
    }
    this.$http.get(window.context.portal+'/sys/sysMenu/v1/getCurrentUserMenu?menuAlias=front_menu').then(reponse => {
      this.copy_Menus=reponse.data.value;
      console.log(reponse.data.value);
    })
    let isFalg = false;
    //模块开发添加为前端菜单点击待办处理任务时判断
    if (
      this.$route.matched.length == 1 &&
      JSON.stringify(this.$route.params) != "{}"
    ) {
      isFalg = false;
    }
    if (
      this.$route.matched.length == 1 &&
      JSON.stringify(this.$route.params) == "{}"
    ) {
      isFalg = true;
    }
    if (this.$route.matched.length > 1) {
      isFalg = true;
    }
    if (!this.currentMenu.alias && isFalg) {
      const this_ = this;
      this_.$store.dispatch("menu/getStaticMenus").then(() => {
        this_.$store.dispatch("menu/getDefaultMenus").then(() => {
          if (sessionStorage.menu_alias) {
            this_.activeMenuIndex = sessionStorage.menu_alias;
          }
          this_.handleSelect(this_.activeMenuIndex);
        });
      });
    }
    this.$root.$on("resize", this.resizeTimerTrigger);
    console.log(this)
    this.$http.get(window.context.portal +"/bpm/haiyaapi/isReadNews?account="+this.account).then((response) => { 
      this.isRead = response.data;
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
@import "@/assets/css/iconfont.scss";
/deep/ .el-row{
  background: #9D9FAD !important;
}

/deep/ .New_Menu{
  width: 64px;
  height: 80px;
  background: #FFFFFF !important;


  p{
    width: 100%;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #9D9FAD;
    text-align:center;
    padding: 8px 0px 0px 0px;
    text-align: center;
  }
  li{
    width: 100%;
    height: 80px;
    text-align: center;
    padding: 0px !important;
  }
  i{
    width: 100%;
    margin: 0px !important;
    padding: 20px 0px 0px 0px;
    text-align: center;
  }

}

// /deep/ .New_Menu:hover{
//   p{
//     font-size: 14px;
//     font-family: PingFang SC-Regular, PingFang SC;
//     font-weight: 400;
//     color: #1890FF;
//     text-align:center;
//   }
// }

/deep/ .el-menu {
    border-right-width: 0px !important;
}

/deep/ .el-submenu__title{
  padding: 0px !important;
  span{
    font-size: 14px !important;
    font-family: PingFang SC-Semibold, PingFang SC !important;
    font-weight: 600 !important;
    color: #292B44 !important;
  }
}

/deep/ .el-submenu .el-menu-item{
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  height: 44px !important;
  line-height: 44px !important;
  padding: 0px 0px 0px 30px !important;
  width:100% !important;
  min-width: 100px !important;
}
/deep/ .el-menu-item.is-active {
  // background: #E4F6FF;
  // box-shadow: inset -3px 0px 0px 0px #1890FF;
  p{
    color: #1890FF;
  }
}



.el-menu--horizontal .el-menu-item:not(.is-disabled.is-active):hover,
.el-menu--horizontal .el-menu-item:not(.is-disabled.is-active):focus {
  outline: none;
  outline-color: initial;
  outline-style: none;
  outline-width: initial;
}

.el-menu-item /deep/{
  font-size: 14px !important;
  font-weight:bolder;
}

.el-menu-demo {
  .el-menu-item {
    &:hover {
      color: $--color-primary !important;
    }
  }
}

</style>
